export enum PopConfirmPlacement {
  TopLeft = 'topLeft',
  Top = 'top',
  TopRight = 'topRight',
  LeftTop = 'leftTop',
  Left = 'left',
  LeftBottom = 'LeftBottom',
  RightTop = 'rightTop',
  Right = 'right',
  RightBottom = 'rightBottom',
  BottomLeft = 'bottomLeft',
  Bottom = 'bottom',
  BottomRight = 'bottomRight'
}
